import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { optional } from '@nullvoxpopuli/ember-composable-helpers';
import UiButton from 'garaje/components/ui-button';
import preventDefault from 'garaje/helpers/prevent-default';

interface UiSearchSignature {
  Args: {
    inputAriaLabel?: string;
    inputId?: string;
    onClear?: (event: Event) => void;
    onClick?: (event: Event) => void;
    onInput?: (event: Event) => void;
    placeholder?: string;
    showClearButton?: boolean;
    value?: string;
  };
  Element: HTMLInputElement;
}

export default <template>
  <div class="relative">
    <input
      type="search"
      class="pageSearch rounded-lg border icon-search {{if @showClearButton '!pr-8'}}"
      id={{@inputId}}
      aria-label={{@inputAriaLabel}}
      {{on "input" (optional @onInput)}}
      {{on "click" (optional @onClick)}}
      placeholder={{@placeholder}}
      value={{@value}}
      data-test-search-input
      ...attributes
    />
    <UiButton
      class="icon-cross-small-gray btn--clear-search {{unless @showClearButton 'hidden'}}"
      {{on "click" (preventDefault (optional @onClear))}}
      data-test-clear-search-button
    >
      <span class="sr-only">Clear Search</span>
    </UiButton>
  </div>
</template> satisfies TOC<UiSearchSignature>;
